import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Signin from './components/Login';
import Signup from './components/Signup';
import Portfolio from './components/Portfolio';
import Settings from './components/Settings';
import MyData from './components/MyData';
import Trade from './components/Trade';
import Performance from './components/Performance';
import Predictions from "./components/predictions";
import PortfolioTypeSelector from './components/PortfolioTypeSelector';
import PortfolioDetails from './components/PortfolioDetails';
import TickerDetail from './components/TickerDetail';
import KycRouter from './components/KycRouter';
import KycGuard from './components/KycGuard';
import ManageMoney from './components/ManageMoney';
import AiAdvisor from './components/AiAdvisor';
import { applyTheme, getThemeKey } from './styles/theme';
import './chartConfig';

// ==============================
// Import dei componenti KYC dalla sottocartella kyc/
// ==============================
import EmailVerification from './components/kyc/EmailVerification';
import PhoneVerification from './components/kyc/PhoneVerification';
import PersonalData from './components/kyc/PersonalData';
import DocumentUpload from './components/kyc/DocumentUpload';
import MembershipSelection from './components/kyc/MembershipSelection';
import PaymentSetup from './components/kyc/PaymentSetup';
import PrivacyConsents from './components/kyc/PrivacyConsents';
import FatcaQuestionnaire from './components/kyc/FatcaQuestionnaire';
import ContractSignature from './components/kyc/ContractSignature';
import MifidQuestionnaire from './components/kyc/MifidQuestionnaire';
import TradingModeSelection from './components/kyc/TradingModeSelection';
import AutopilotIntro from './components/kyc/AutopilotIntro';
import AlpacaOnboarding from './components/kyc/AlpacaOnboarding';

// Forza il tema kuesto durante il KYC e lo ripristina all'uscita
const KycThemeWrapper = ({ children }) => {
  useEffect(() => {
    applyTheme('kuesto');
    return () => applyTheme(getThemeKey());
  }, []);
  return children;
};

function App() {
  // Applica il tema salvato in localStorage al primo caricamento
  useEffect(() => {
    applyTheme(getThemeKey());
  }, []);

  return (
    <Router>
      <Routes>
        {/* ===== Route pubbliche ===== */}
        <Route path="/" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Signin />} />

        {/* ===== Route KYC (sempre tema kuesto) ===== */}
        <Route path="/kyc" element={<KycThemeWrapper><KycRouter /></KycThemeWrapper>} />
        <Route path="/kyc/email-verification" element={<KycThemeWrapper><EmailVerification /></KycThemeWrapper>} />
        <Route path="/kyc/phone-verification" element={<KycThemeWrapper><PhoneVerification /></KycThemeWrapper>} />
        <Route path="/kyc/personal-data" element={<KycThemeWrapper><PersonalData /></KycThemeWrapper>} />
        <Route path="/kyc/document-upload" element={<KycThemeWrapper><DocumentUpload /></KycThemeWrapper>} />
        <Route path="/kyc/membership" element={<KycThemeWrapper><MembershipSelection /></KycThemeWrapper>} />
        <Route path="/kyc/payment-setup" element={<KycThemeWrapper><PaymentSetup /></KycThemeWrapper>} />
        <Route path="/kyc/privacy-consents" element={<KycThemeWrapper><PrivacyConsents /></KycThemeWrapper>} />
        <Route path="/kyc/fatca" element={<KycThemeWrapper><FatcaQuestionnaire /></KycThemeWrapper>} />
        <Route path="/kyc/contract-signature" element={<KycThemeWrapper><ContractSignature /></KycThemeWrapper>} />
        <Route path="/kyc/mifid" element={<KycThemeWrapper><MifidQuestionnaire /></KycThemeWrapper>} />
        <Route path="/kyc/trading-mode" element={<KycThemeWrapper><TradingModeSelection /></KycThemeWrapper>} />
        <Route path="/kyc/autopilot" element={<KycThemeWrapper><AutopilotIntro /></KycThemeWrapper>} />
        <Route path="/kyc/alpaca-onboarding" element={<KycThemeWrapper><AlpacaOnboarding /></KycThemeWrapper>} />

        {/* ===== Route protette da KYC ===== */}
        <Route path="/select-portfolio-type" element={
          <KycGuard><PortfolioTypeSelector /></KycGuard>
        } />
        <Route path="/portfolio" element={
          <KycGuard><Portfolio /></KycGuard>
        } />
        <Route path="/portfolio-details" element={
          <KycGuard><PortfolioDetails /></KycGuard>
        } />
        <Route path="/trade" element={
          <KycGuard><Trade /></KycGuard>
        } />
        <Route path="/performance" element={
          <KycGuard><Performance /></KycGuard>
        } />
        <Route path="/predictions" element={
          <KycGuard><Predictions /></KycGuard>
        } />
        <Route path="/ticker/:ticker" element={
          <KycGuard><TickerDetail /></KycGuard>
        } />
        <Route path="/manage-money" element={
          <KycGuard><ManageMoney /></KycGuard>
        } />
        <Route path="/ai-advisor" element={
          <KycGuard><AiAdvisor /></KycGuard>
        } />
        <Route path="/settings" element={<Settings />} />
        <Route path="/my-data" element={<KycGuard><MyData /></KycGuard>} />
      </Routes>
    </Router>
  );
}

export default App;
